module.exports = __webpack_public_path__ + "img/ico_5.78039748.svg";